var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caseTop",style:({width:this.screenWidth+'px', height:this.top+'px'})},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.image}}),_c('p',{staticClass:"topTitle"},[_vm._v(_vm._s(_vm.topTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }